import { CartographySelectorModal } from 'sonata-platform-components';
import { normalizeCountryToCca3 } from 'sonata-static-storage/lib/helpers/countries.helpers';

import { useMultiFlightMap } from '@/components/common/MultiFlightMap/MultiFlightMap.context';
import { generateZonesFromAdminBoundaryItems } from '@/components/common/MultiFlightMap/MultiFlightMap.helpers';
import { useModals } from '@/router';

import type { AdminBoundariesChangeItem } from 'sonata-platform-components';

export default function CartographyModal() {
  const { countries, onSaveCartographicLocations, user, userRoles } = useMultiFlightMap();
  const campaignCountries = countries.map(item => normalizeCountryToCca3(item).toUpperCase());
  const modals = useModals();

  const handleSaveZones = async (items: AdminBoundariesChangeItem[]) => {
    const newCartographicZones = await generateZonesFromAdminBoundaryItems(items);
    onSaveCartographicLocations(newCartographicZones);
    modals.close();
  };

  return (
    <CartographySelectorModal
      disabledSelectorCountry={false}
      id="global-cartography-selector-modal"
      initialCountry={campaignCountries[0]}
      isModalOpened
      limitedCountries={campaignCountries}
      onClose={() => modals.close()}
      onSave={handleSaveZones}
      sonataLICountries={false}
      theme="light"
      user={user}
      userRoles={userRoles}
    />
  );
}
